import { TanStackDevtools } from "@tanstack/react-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { FormDevtools, TanStackQueryDevtools, TanStackRouterDevtools } from "@/lib/devtools";
import type { MyRouterContext } from "@/router";

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <>
      <Outlet />
      <TanStackDevtools
        config={{ position: "bottom-left" }}
        plugins={[TanStackQueryDevtools, TanStackRouterDevtools, FormDevtools]}
      />
    </>
  ),
});
